import { useState } from 'react';

export const useSearch = () => {
  const [searchIsOpen, setSearchOpen] = useState(false);
  const [isLoading] = useState(false);

  const onToggle = () => {
    setSearchOpen(prevState => !prevState);
  };

  return {
    searchIsOpen,
    isLoading,
    onToggle,
  };
};

export type ISearchProps = ReturnType<typeof useSearch>;
